export const useHtmlExport = () => {
  const getStyledHtml = (element: HTMLElement | Element) => {
    const clone = element.cloneNode(true) as HTMLElement
    const documentCss = getDocumentCss()
    return `<div><style>${documentCss}</style>${clone.outerHTML}</div>`
  }

  const getDocumentCss = () => {
    return [...document.styleSheets]
      .map(styleSheet => {
        try {
          return [...styleSheet.cssRules].map(rule => rule.cssText).join('')
        } catch (e) {
          console.log(
            'Access to stylesheet %s is denied. Ignoring…',
            styleSheet.href
          )
        }
      })
      .filter(Boolean)
      .join(' ')
  }

  return { getStyledHtml }
}
